import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadToSbriefArchivListStatus: 'idle',
    loadToSbriefArchivListError: undefined as any,
    loadToSbriefArchivListLastArgs: undefined as any,
    loadToSbriefArchivStatus: 'idle',
    loadToSbriefArchivError: undefined as any,

    toSbriefArchivList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadToSbriefArchivList = createAsyncThunk('toSbriefArchivSlice/loadToSbriefArchivList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().toSbriefArchivSlice.loadToSbriefArchivListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/ncremserienbrief/?action=gte&MIN_MODULTYPE=3&MAX_MODULTYPE=3&MIN_MODULOBJID=${parentModel.HDR_ID}&MAX_MODULOBJID=${parentModel.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadToSbriefArchivListStatus } = getState().toSbriefArchivSlice
        return loadToSbriefArchivListStatus !== 'pending'
    }
})

export const loadToSbriefArchiv = createAsyncThunk('toSbriefArchivSlice/loadToSbriefArchiv', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/ncremserienbrief/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadToSbriefArchivStatus } = getState().toSbriefArchivSlice
        return loadToSbriefArchivStatus !== 'pending'
    }
})

const ToSbriefArchivSlice = createSlice({
    name: 'toSbriefArchivSlice',
    initialState,
    reducers: {
        resetloadToSbriefArchivListError: (state) => {
            state.loadToSbriefArchivListError = undefined
        },
        resetloadToSbriefArchiv: (state) => {
            state.formItem = undefined
            state.loadToSbriefArchivError = undefined
        },
        resetloadToSbriefArchivError: (state) => {
            state.loadToSbriefArchivError = undefined
        },
        removeFromToSbriefArchivListById: (state, action) => {
            state.toSbriefArchivList = state.toSbriefArchivList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromToSbriefArchivListByIds: (state, action) => {
            state.toSbriefArchivList = state.toSbriefArchivList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.toSbriefArchivList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadToSbriefArchivListStatus = 'preloaded'
            state.loadToSbriefArchivListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.toSbriefArchivList = []
            state.loadToSbriefArchivListStatus = 'idle'
            state.loadToSbriefArchivListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadToSbriefArchivList.pending, (state) => {
            state.loadToSbriefArchivListStatus = 'pending'
            state.loadToSbriefArchivListError = undefined
        })
        builder.addCase(loadToSbriefArchivList.fulfilled, (state, action) => {
            state.loadToSbriefArchivListStatus = 'idle'

            if (!action.payload) { return }

            state.loadToSbriefArchivListLastArgs = action.payload.args

            {
                state.toSbriefArchivList = action.payload.data

            }
        })
        builder.addCase(loadToSbriefArchivList.rejected, (state, action) => {
            state.loadToSbriefArchivListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadToSbriefArchivListError = action.error.message
            } else {
                state.loadToSbriefArchivListError = action.payload
            }
        })

        builder.addCase(loadToSbriefArchiv.pending, (state) => {
            state.loadToSbriefArchivStatus = 'pending'
            state.loadToSbriefArchivError = undefined
        })
        builder.addCase(loadToSbriefArchiv.fulfilled, (state, action) => {
            state.loadToSbriefArchivStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.toSbriefArchivList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.toSbriefArchivList.push(newItem) }
                else { state.toSbriefArchivList[i] = { ...state.toSbriefArchivList[i], ...newItem } }
            }
        })
        builder.addCase(loadToSbriefArchiv.rejected, (state, action) => {
            state.loadToSbriefArchivStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadToSbriefArchivError = action.error.message
            } else {
                state.loadToSbriefArchivError = action.payload
            }
        })

    }
})

export const {
    resetloadToSbriefArchivListError,
    resetloadToSbriefArchiv,
    resetloadToSbriefArchivError,
    removeFromToSbriefArchivListById,
    removeFromToSbriefArchivListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ToSbriefArchivSlice.actions
export default ToSbriefArchivSlice.reducer
